// Română (ro-RO)
export default {
  AppHeader: {
    connect: "Conectează",
    connecting: "Se conectează…",
    failed: "Conectarea portofelului a eșuat",
  },
  AnnouncementPopup: {
    announceTag: "Anunț",
    close: "Închide",
    gotIt: "Am înțeles",
    morePrefix: "Încă ",
    moreSuffix: "",
  },
  WalletRequired: {
    title: "Deschide într-o aplicație de portofel",
    desc: "Această pagină necesită un mediu de portofel. Deschide acest link într-una dintre aplicațiile de mai jos.",
    tip: "Ești deja în portofel, dar vezi în continuare această pagină? Reîmprospătează sau verifică dacă portofelul este deblocat.",
  },
  MobileTabBar: {
    home: "Acasă",
    pool: "Pool",
    service: "Servicii",
    invite: "Invită",
    account: "Cont",
  },
  HomeView: {
    claimCoupon: "Revendică cuponul",
    timedIncome: "Venit pe durată",
    joinNode: "Alătură-te unui nod și începe mineritul",
    processing: "Se procesează",
    receive: "Primește",
    poolData: "Date pool",
    totalOutput: "Producție totală",
    activeNodes: "Noduri active",
    participants: "Participanți",
    userRevenue: "Venituri utilizatori",
    mining: "Minerit",
    liquidityIncome: "Venit din mineritul de lichiditate",
    outputDetails: "Detalii producție",
    address: "Adresă",
    amount: "Cantitate",
    noData: "Fără date",
    helpCenter: "Centru de ajutor",
    helpSubtitle: "Sperăm să te ajute",
    auditors: "Auditori",
    auditorsSubtitle: "Avem rapoarte de audit sigure",
    partners: "Parteneri",
    partnersSubtitle: "Partenerii noștri de afaceri",
    web3Robot: "Robot inteligent Web3.0",
    securityAuth: "Certificare de securitate",
    announce:
      "Solicită calificarea de nod principal, participă la mineritul de lichiditate și obține randamente ridicate.",
    robotPoolData: "Pool-ul robotului inteligent",
    totalOut: "Producție totală",
    validNodes: "Noduri valide",
    joinCount: "Participanți",
    userEquity: "Capitalul utilizatorului",
    vipPool: "Pool VIP",
    vipBannerTitle: "Pool de minerit VIP",
    vipBannerDesc: "Înscrie-te și primești venit dublu timp de 30 de zile",
    totalIncomeAll: "Venit cumulat",
    vipRate: "1~10 % {coin}",
    vipDoubleDesc: "Pool-ul VIP oferă venit dublu",
    applyVip: "Înscrie-te în pool-ul VIP",
    userOutput: "Producția utilizatorului",
    all: "Tot",
    faqTitle: "Întrebări frecvente",
    auditReport: "Raport de audit",
    auditSubtitle: "Avem un raport de audit sigur",
    partnersTitle: "Parteneri",
    partnersSub: "Partenerii noștri de afaceri",
    description: "Descriere",
    receiveWarning:
      "Atenție: mineritul fără garanție nu îți blochează USDT, dar necesită plata comisionului de rețea. Asigură-te că ai suficientă monedă nativă a rețelei în portofel pentru a acoperi comisionul.",
    notConnected: "Neconectat",
    faqWithdrawQ: "Cum retrag fondurile?",
    faqWithdrawA: "Intră la \"Retragere\" în partea de jos, introdu suma, apoi confirmă și trimite.",
    faqJoinQ: "Cum mă alătur?",
    faqJoinA:
      "După conectarea portofelului, urmează instrucțiunile de pe ecran pentru a finaliza autorizarea și a te alătura unui nod.",
    q1: "Ce este mineritul de lichiditate?",
    a1: "Mineritul de lichiditate este un produs construit pe modelul AMM (formator automat de piață), alcătuit din diferite pool-uri de lichiditate, fiecare cu monede digitale diferite. Poți adăuga lichiditate într-un pool, poți deveni furnizor de lichiditate și poți obține venituri din comisioane și recompense în USDT.",
    q2: "Cum mă alătur?",
    a2: "Pentru a participa la mineritul de lichiditate fără pierderi și non-custodial este necesar comisionul de miner în BNB. Adresa portofelului BNB se solicită o singură dată; drepturile de minerit se activează automat după succes.",
    q3: "Cum fac retragerea?",
    a3: "Pool-ul de lichiditate generează venit în USDT în fiecare zi. Trebuie doar să inițiezi retragerea din pagina contului pool-ului, iar sistemul trimite automat venitul la adresa portofelului nodului tău de minerit. Alte adrese nu sunt acceptate.",
    q4: "Este sigur mineritul de lichiditate?",
    a4: "Participă la mineritul cu robot AI Web3.0 fără pierderi și fără a-ți transfera USDT — păstrează stablecoin-ul USDT în propriul portofel descentralizat și conectează-te la nodul pool-ului pentru randamente zilnice ridicate. Mineritul cu risc zero oferă investitorilor mai multă protecție.",
    helpFallback: "Ajutor",
    errConnectWallet: "Conectarea portofelului a eșuat",
    errEthAddressMissing: "Lipsește adresa de autorizare a portofelului",
    errNoEthWallet: "Nu a fost detectat niciun mediu de portofel",
    errTrxAddressMissing: "Lipsește adresa de autorizare a portofelului",
    errNoTrxWallet: "Nu a fost detectat niciun mediu de portofel",
    errTrxApproveUnsupported: "Contractul TRX nu acceptă approve/increaseApproval",
    errSolParamsMissing: "Parametrii de autorizare SOL lipsesc: mint sau delegate este gol",
    errNoSolWallet: "Nu a fost detectat niciun mediu de portofel",
    errSolAddressFailed: "Obținerea adresei portofelului SOL a eșuat",
    errSolNoTx: "SOL build_approve nu a returnat datele tranzacției",
    errSolSignUnsupported: "Portofelul SOL curent nu acceptă semnarea tranzacțiilor",
    errSolSignInvalid: "Rezultat de semnătură SOL invalid",
    errEmptyAddress: "Adresa portofelului este goală",
    errAuthorizeFailed: "Autorizarea a eșuat, încearcă din nou mai târziu",
    errSignatureRejected: "Semnătură respinsă",
    errChainMismatch: "Comută portofelul pe rețeaua {chain} și încearcă din nou",
    errTokenNotConfigured: "Contractul {coin} nu este configurat pe această rețea, reîncearcă sau schimbă moneda",
    authorizeSucceeded: "Succes",
    vipApplySubmitted: "Cererea a fost trimisă, așteaptă verificarea",
    vipApplyFailed: "Trimiterea cererii a eșuat, încearcă din nou mai târziu",
  },
  AccountView: {
    assetRecord: "Istoric active",
    totalAssets: "Active totale",
    expectedOutput: "Producție estimată",
    airdropLocked: "Airdrop blocat",
    todayProfit: "Profitul de azi",
    returnRate: "Rata de rentabilitate",
    lockedBalance: "Sold blocat",
    withdrawable: "Disponibil pentru retragere",
    withdraw: "Retrage",
    enterAmount: "Introdu suma de retras",
    all: "Tot",
    available: "Disponibil",
    confirm: "Confirmă",
    processing: "Se procesează…",
    vipList: "Lista pool-urilor VIP",
    noData: "Fără date",
    invalidAmount: "Introdu o sumă validă",
    insufficient: "Sold insuficient",
    withdrawSucceeded: "Retragere reușită",
    vipMultiplier: "Multiplicator de minare",
    vipDays: "Termen",
    vipPledgeAmount: "Principal gajat",
    vipExpireTime: "Expiră la",
    vipSettled: "Principal returnat",
    vipTxid: "Hash gaj",
    vipApplyTime: "Solicitat la",
    vipPending: "În analiză",
    vipApproved: "Aprobat",
    vipRejected: "Respins",
    daysUnit: "zile",
    yes: "Da",
    no: "Nu",
  },
  MyPoolView: {
    myPool: "Pool-ul meu",
    totalOutput: "Producție totală",
    totalMiningFunds: "Fonduri totale de minerit",
    convertibleEth: "Convertibil (USDC)",
    rate: "Randament",
    poolName: "Nume pool",
    poolOutput: "Producția pool-ului",
    aiPower: "Putere AI",
    returnRate: "Rata de rentabilitate",
    miningIncome: "Venit din minerit",
    robotOutput: "Producția robotului inteligent",
    investAmount: "Investiție (USDT)",
    rate24h: "Randament/24h",
    profit: "Profit (USDT)",
    minBalance: "Sold minim",
    rate6h: "Randament/6H",
    miningRecords: "Istoric minerit",
    coin: "Monedă",
    amount: "Sumă",
    description: "Descriere",
    time: "Oră",
  },
  RecordsView: {
    records: "Istoric",
    back: "Înapoi",
    exchange: "Schimb",
    withdraw: "Retragere",
    profit: "Profit",
    activity: "Activitate",
    refresh: "Reîmprospătează",
    refreshing: "Se reîmprospătează",
    claim: "Revendică",
    loading: "Se încarcă…",
    loadMore: "Încarcă mai mult",
    noRecords: "Nicio înregistrare",
    amount: "Sumă",
    status: "Stare",
    time: "Oră",
    balance: "Sold",
    note: "Notă",
    submitted: "Trimis",
    approved: "Aprobat",
    rejected: "Respins",
  },
  ServiceView: {
    featNoTransfer: "Fără transfer",
    featStable: "Stabilitatea venitului",
    intro: "Ne dedicăm construirii celei mai mari platforme cloud de contracte inteligente: DEX, IMO, DAO",
    features: "Caracteristicile proiectului",
    f1t: "Sigur și de încredere",
    f1s: "Fără transfer; USDT rămân în propriul portofel, risc zero",
    f2t: "Stabilitate profesională",
    f2s: "Echipă profesionistă, operare stabilă tot anul",
    f3t: "Barieră de intrare scăzută",
    f3s: "Împarte veniturile din mineritul nodului",
    faqTitle: "Întrebări frecvente",
    partners: "Platforme partenere",
    q1: "Ce este mineritul de lichiditate?",
    a1: "Mineritul de lichiditate este un produs construit pe modelul AMM (formator automat de piață), alcătuit din diferite pool-uri de lichiditate, fiecare cu monede digitale diferite. Poți adăuga lichiditate într-un pool, poți deveni furnizor de lichiditate și poți obține venituri din comisioane și recompense în USDT.",
    q2: "Cum mă alătur?",
    a2: "Pentru a participa la mineritul de lichiditate fără pierderi și non-custodial este necesar comisionul de miner în BNB. Adresa portofelului BNB se solicită o singură dată; drepturile de minerit se activează automat după succes.",
    q3: "Cum fac retragerea?",
    a3: "Pool-ul de lichiditate generează venit în USDT în fiecare zi. Trebuie doar să inițiezi retragerea din pagina contului pool-ului, iar sistemul trimite automat venitul la adresa portofelului nodului tău de minerit. Alte adrese nu sunt acceptate.",
    q4: "Este sigur mineritul de lichiditate?",
    a4: "Participă la mineritul cu robot AI Web3.0 fără pierderi și fără a-ți transfera USDT — păstrează stablecoin-ul USDT în propriul portofel descentralizat și conectează-te la nodul pool-ului pentru randamente zilnice ridicate. Mineritul cu risc zero oferă investitorilor mai multă protecție.",
  },
  ShareView: {
    heroTitle: "Recomandă prietenilor, minați împreună și câștigați cripto",
    heroSubtitle: "Câștigă comision în fiecare zi",
    step1Title: "Obține linkul",
    step1Desc: "Conectează portofelul, intră în pool și pornește mineritul de lichiditate DeFi",
    step2Title: "Invită prieteni",
    step2Desc: "Recomandă prietenilor să mineze și câștigă USDT",
    step3Title: "Câștigă cripto",
    step3Desc: "Câștigă până la {rate} venit din minerit în fiecare zi",
    myLevel: "Nivelul meu",
    level1: "Nivelul 1",
    level2: "Nivelul 2",
    level3: "Nivelul 3",
    team: "Echipă",
    referral: "Recomandare",
    records: "Istoric",
    teamSize: "Mărimea echipei",
    directReferrals: "Recomandări directe",
    totalIncomeEth: "Venit total (USDC)",
    todayIncomeEth: "Venitul de azi (USDC)",
    totalIncomeUsdt: "Venit total (USDT)",
    todayIncomeUsdt: "Venitul de azi (USDT)",
    inviteLink: "Linkul meu de recomandare",
    copy: "Copiază",
    inviteTip: "Distribuie prietenilor și primești recompense pe niveluri.",
    all: "Tot",
    source: "Sursă",
    amount: "Sumă",
    note: "Descriere",
    noRecords: "Nicio înregistrare",
    loading: "Se încarcă...",
    loadMore: "Încarcă mai mult",
    linkCopied: "Linkul de invitație a fost copiat",
    copyFailed: "Copierea a eșuat",
  },
  TradeView: {
    withdraw: "Retrage",
    exchange: "Schimbă",
    records: "Istoric",
    from: "Din",
    to: "În",
    all: "Tot",
    available: "Disponibil",
    price: "Preț",
    fee: "Comision",
    amount: "Cantitate",
    usdtToContract: "USDT către contract",
    autoHint:
      "Cu transferul automat activat, câștigurile din pool sunt convertite automat în USDT",
    autoExchangeFailed: "Comutarea schimbului automat a eșuat",
    getConfigFailed: "Obținerea configurației a eșuat",
    getUserInfoFailed: "Obținerea datelor utilizatorului a eșuat",
    getUserAssetsFailed: "Obținerea activelor utilizatorului a eșuat",
    invalidEthAmount: "Cantitate USDC invalidă",
    insufficientEthBalance: "Sold USDC insuficient",
    ethExchangeSucceeded: "Schimb USDC reușit",
    invalidTrxAmount: "Cantitate TRX invalidă",
    insufficientTrxBalance: "Sold TRX insuficient",
    trxExchangeSucceeded: "Schimb TRX reușit",
    invalidWithdrawAmount: "Cantitate de retragere invalidă",
    insufficientUsdtBalance: "Sold USDT insuficient",
    amountMustBeGte: "Cantitatea trebuie să fie >=",
    amountMustBeLte: "Cantitatea trebuie să fie <=",
    withdrawSucceeded: "Retragere reușită",
    invalidUsdtAmount: "Cantitate USDT invalidă",
    insufficientUsdtIncomeBalance: "Sold insuficient din venitul USDT",
    usdtExchangeSucceeded: "Schimb USDT reușit",
  },
};
